import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a758710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-info-container" }
const _hoisted_2 = {
  key: 0,
  class: "content-area",
  ref: "contentArea"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 버스 출발시간은 도로교통 사정상 오차가 있을 수 있습니다. 표기되고 있는 운행시간은 “평균”운행시간을 기준으로 목표시간을 설정한 것 입니다. 기점 출발 이후에 자세한 버스위치는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "modal-content emphasis" }, "실시간 버스위치"),
  /*#__PURE__*/_createTextVNode("를 참고해 주세요. ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          class: "navigation-bar",
          title: "노선정보",
          shouldShowUnderline: true
        }),
        (!!$setup.lineInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode($setup["LineInfoDetailHeader"], {
                class: "header",
                lineInfo: $setup.lineInfo!
              }, null, 8 /* PROPS */, ["lineInfo"]),
              _createVNode($setup["LineInfoDetailContent"], {
                lineInfo: $setup.lineInfo!,
                availableTimes: $setup.availableTimes,
                selectedTimeIndex: $setup.selectedTimeIndex,
                turnInfo: $setup.lineInfo.turns[$setup.selectedTimeIndex],
                departureTime: $setup.availableTimes[$setup.selectedTimeIndex],
                hasDifferentTimes: $setup.availableTimes.length > 1,
                lineFares: [],
                isInsideShuttle: $setup.isInsideShuttle,
                onOnClickSelectTime: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSelectTimeModal(true)))
              }, null, 8 /* PROPS */, ["lineInfo", "availableTimes", "selectedTimeIndex", "turnInfo", "departureTime", "hasDifferentTimes", "isInsideShuttle"]),
              _createVNode($setup["LineInfoDetailSelectBusStop"], {
                class: "select-bus-stop",
                lineId: $setup.lineInfo?.id ?? '',
                turnId: $setup.selectedTurn?.id ?? '',
                busStops: $setup.selectedTurn?.busStops ?? [],
                favoriteLine: $setup.currentFavoriteLine,
                isInsideShuttle: $setup.isInsideShuttle,
                onOnClickBusStopLocation: $setup.showMap,
                onOnClickBusStopTimeGuide: _cache[1] || (_cache[1] = ($event: any) => ($setup.showBusStopTimeGuide = true)),
                onUpdateBusLocation: $setup.getBusLocation,
                onOnClickScheduleBtn: $setup.showTimeTable
              }, null, 8 /* PROPS */, ["lineId", "turnId", "busStops", "favoriteLine", "isInsideShuttle"])
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.showSelectTimeModal)
        ? (_openBlock(), _createBlock($setup["SelectModal"], {
            key: 0,
            contents: $setup.availableTimes,
            initialIndex: $setup.selectedTimeIndex,
            onHideModal: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSelectTimeModal(false))),
            onOnItemSelected: $setup.onTimeSelected
          }, null, 8 /* PROPS */, ["contents", "initialIndex"]))
        : _createCommentVNode("v-if", true),
      ($setup.showBusStopTimeGuide)
        ? (_openBlock(), _createBlock($setup["InfoModal"], {
            key: 1,
            title: "운행시간 안내",
            confirmButtonTitle: "닫기",
            onOnClickConfirmButton: _cache[3] || (_cache[3] = ($event: any) => ($setup.showBusStopTimeGuide = false))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowMap,
        onBackHandler: () => $setup.toggleShowMap(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["MapOfBusStop"], {
            targetBusStop: $setup.selectedBusStopForLocation,
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowMap(false)))
          }, null, 8 /* PROPS */, ["targetBusStop"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTimeTable && !!$setup.targetBusStopForTimeTable,
        onBackHandler: () => $setup.toggleShowTimeTable(false)
      }, {
        default: _withCtx(() => [
          ($setup.targetBusStopForTimeTable)
            ? (_openBlock(), _createBlock($setup["TimeTableModal"], {
                key: 0,
                turnId: $setup.selectedTurn?.id ?? '',
                busStop: $setup.targetBusStopForTimeTable,
                onOnClickCloseBtn: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowTimeTable(false)))
              }, null, 8 /* PROPS */, ["turnId", "busStop"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}